import React from "react";
import { FC } from "react";

type CoinsProps = {
    coins: number;
    size?: number;
    fontSize?: number;
}

export const Coins: FC<CoinsProps> = ({ coins, size, fontSize }) => {

    return (
        <>
            <span className={`fs-${fontSize ?? 4}`}>{coins}</span>
            <img
                src="/img/tinker-coin.png"
                width={size ?? 20}
                height={size ?? 20}
                className="d-inline-block align-top ms-1 mt-2"
                alt="tinker-coins"
            />
        </>
    )
}